<template>
  <workshop-featured-section :workshop-type="workshopType"/>
</template>

<script>
import WorkshopFeaturedSection from './WorkshopFeaturedSection.vue'

export default {
  name: 'CurrentAndUpcomingWorkshops',
  metaInfo: {
    title: 'Workshops'
  },
  components: { WorkshopFeaturedSection },
  props: ['workshopType']
}
</script>
